<script lang="ts">
  import { filterNews } from "../../services"
  import CuratorsFilters from "../../../../custom/Curators/CuratorsFilters.svelte"
</script>

<CuratorsFilters on:change={filterNews} />